export default __webpack_public_path__ + "static/media/pyesu_start.0188c221.svg";